import React from 'react';
import { FaReact, FaNodeJs } from 'react-icons/fa';
import { SiAndroidstudio } from 'react-icons/si';
import styled from 'styled-components';

import SectionTitle from './SectionTitle';
import StacksSectionItem from './StacksSectionItem';

const StacksItemsStyles = styled.div`
  padding: 10rem 0;
  .stacks__allItems {
    display: flex;
    gap: 10rem;
    justify-content: space-between;
    margin-top: 5rem;
  }
  @media only screen and (max-width: 768px) {
    .stacks__allItems {
      flex-direction: column;
      max-width: 350px;
      margin: 0 auto;
      margin-top: 5rem;
      gap: 5rem;
    }
  }
`;

export default function StacksSection() {
  return (
    <StacksItemsStyles>
      <div className="container">
        <SectionTitle subheading="Minhas ferramentas" heading="Tecnologias" />
        <div className="stacks__allItems">
          <StacksSectionItem
            icon={<FaReact />}
            title="React JS"
            desc="O React é uma biblioteca JavaScript declarativa, eficiente e flexível para criar interfaces com o usuário. Ele permite compor UIs complexas a partir de pequenos e isolados códigos chamados “componentes”."
          />
          <StacksSectionItem
            icon={<FaNodeJs />}
            title="Node JS"
            desc="O Node.js é construído em versões modernas do V8 . Ao nos mantermos atualizados com as versões mais recentes desse mecanismo, garantimos que novos recursos da especificação JavaScript ECMA-262 sejam levados aos desenvolvedores do Node.js em tempo hábil, bem como melhorias contínuas de desempenho e estabilidade"
          />
          <StacksSectionItem
            icon={<SiAndroidstudio />}
            title="Android Studio"
            desc="O Android Studio é o ambiente de desenvolvimento integrado (IDE, na sigla em inglês) oficial para o desenvolvimento de apps Android e é baseado no IntelliJ IDEA . Além do editor de código e das ferramentas de desenvolvedor avançadas do IntelliJ, o Android Studio oferece ainda mais recursos para aumentar sua produtividade na criação de apps Android"
          />
        </div>
      </div>
    </StacksItemsStyles>
  );
}
